import { render, staticRenderFns } from "./filePreviewModal.vue?vue&type=template&id=70522ea8&scoped=true"
import script from "./filePreviewModal.vue?vue&type=script&lang=js"
export * from "./filePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./filePreviewModal.vue?vue&type=style&index=0&id=70522ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70522ea8",
  null
  
)

export default component.exports